import { render } from "./ListOfClassLearners.vue?vue&type=template&id=79d66908"
import script from "./ListOfClassLearners.vue?vue&type=script&lang=js"
export * from "./ListOfClassLearners.vue?vue&type=script&lang=js"

import "./ListOfClassLearners.vue?vue&type=style&index=0&id=79d66908&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__